<mat-progress-bar [value]="progress"></mat-progress-bar>
<button mat-icon-button class="closeSnackBar" (click)="close()"><mat-icon>close</mat-icon></button>
{{message}}
